import { render, staticRenderFns } from "./AdminTravelDetail.vue?vue&type=template&id=0c302c7e"
import script from "./AdminTravelDetail.vue?vue&type=script&lang=js"
export * from "./AdminTravelDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports